module.exports = __webpack_public_path__ + "static/media/logo-blue-2.8365cae5.svg";